import { render, staticRenderFns } from "./user_machine_learning_query_products.vue?vue&type=template&id=0b01cf00"
import script from "./user_machine_learning_query_products.vue?vue&type=script&lang=js"
export * from "./user_machine_learning_query_products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports